import { render, staticRenderFns } from "./CredentialsList.vue?vue&type=template&id=6fc35578&scoped=true&"
import script from "./CredentialsList.vue?vue&type=script&lang=ts&"
export * from "./CredentialsList.vue?vue&type=script&lang=ts&"
import style0 from "./CredentialsList.vue?vue&type=style&index=0&id=6fc35578&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc35578",
  null
  
)

export default component.exports